// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"a5244be9","336":"9fc482a4","507":"f97f83fe","521":"c29a1db1","686":"7dd80e64"}[chunkId] + ".chunk.css";
};